<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="96"
    height="96"
    viewBox="0 0 96 96"
  >
    <defs>
      <linearGradient id="ewa8ylhjsb" x1="99.999%" x2=".001%" y1="100%" y2="-9.901%">
        <stop offset="0%" />
        <stop offset="100%" stop-color="#FFF" />
      </linearGradient>
      <linearGradient id="t8rv5h313e" x1="100%" x2="0%" y1="99.999%" y2="-9.9%">
        <stop offset="0%" />
        <stop offset="100%" stop-color="#FFF" />
      </linearGradient>
      <filter id="37brnmluzc" width="119.8%" height="119.8%" x="-9.9%" y="-9.9%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5" />
        <feOffset dx="5" dy="-5" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
          values="0 0 0 0 0.650980392 0 0 0 0 0.670588235 0 0 0 0 0.741176471 0 0 0 1 0"
        />
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner2" stdDeviation="5" />
        <feOffset dx="-5" dy="5" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
          values="0 0 0 0 0.980392157 0 0 0 0 0.984313725 0 0 0 0 1 0 0 0 1 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <filter id="8kzbhy1pff" width="132.8%" height="132.8%" x="-16.4%" y="-16.4%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5" />
        <feOffset dx="8" dy="-2" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
          values="0 0 0 0 0.650980392 0 0 0 0 0.670588235 0 0 0 0 0.741176471 0 0 0 1 0"
        />
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner2" stdDeviation="5" />
        <feOffset dx="-2" dy="2" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
          values="0 0 0 0 0.980392157 0 0 0 0 0.984313725 0 0 0 0 1 0 0 0 1 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <path
        id="3jbtdifdsa"
        d="M41.366 62.58l12.436 12.436L32.817 96 20.382 83.565 41.366 62.58zm42.198-42.199L96 32.817 58.465 70.352 46.029 57.916l37.535-37.535z"
      />
      <path
        id="osubgdgg3d"
        d="M34.074 43.878v10.991h-6.595V43.878h6.595zm13.024-8.126l7.772 7.772-4.663 4.664-7.772-7.772 4.663-4.664zm-32.645 0l4.664 4.663-7.772 7.772-4.664-4.663 7.772-7.772zm-3.462-14.956v6.595H0v-6.595h10.991zM11.346 0l7.772 7.772-4.664 4.663-7.772-7.772L11.346 0z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <path d="M0 0H96V96H0z" transform="translate(-725 -419) translate(725 419)" />
          <g transform="translate(-725 -419) translate(725 419) matrix(1 0 0 -1 0 116.381)">
            <use fill="#EBECF0" xlink:href="#3jbtdifdsa" />
            <use
              fill="url(#ewa8ylhjsb)"
              fill-opacity=".4"
              style="mix-blend-mode: soft-light"
              xlink:href="#3jbtdifdsa"
            />
            <use fill="#000" filter="url(#37brnmluzc)" xlink:href="#3jbtdifdsa" />
            <path
              stroke="#FFF"
              stroke-linejoin="square"
              stroke-opacity=".4"
              stroke-width="2"
              d="M41.366 63.994l11.021 11.022-19.57 19.57-11.021-11.021 19.57-19.57zm42.198-42.199l11.021 11.022-36.12 36.12-11.022-11.02 36.121-36.122z"
            />
          </g>
          <g transform="translate(-725 -419) translate(725 419) matrix(1 0 0 -1 0 54.87)">
            <use fill="#EBECF0" xlink:href="#osubgdgg3d" />
            <use
              fill="url(#t8rv5h313e)"
              fill-opacity=".4"
              style="mix-blend-mode: soft-light"
              xlink:href="#osubgdgg3d"
            />
            <use fill="#000" filter="url(#8kzbhy1pff)" xlink:href="#osubgdgg3d" />
            <path
              stroke="#FFF"
              stroke-linejoin="square"
              stroke-opacity=".4"
              stroke-width="2"
              d="M33.074 44.878v8.991h-4.595v-8.991h4.595zm14.024-7.711l6.358 6.357-3.25 3.25-6.357-6.358 3.249-3.25zm-32.645-.001l3.25 3.249-6.358 6.358-3.25-3.25 6.358-6.357zm-4.462-15.37v4.595H1v-4.595h8.991zm1.355-20.382l6.357 6.358-3.249 3.25-6.357-6.359 3.249-3.249z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>
